<template>
  <div class="bg_white">
    <van-nav-bar title="我的考试" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight">
      <template #right>
        <van-icon name="wap-home-o" size="20" />
      </template>
    </van-nav-bar>
    <van-cell-group inset v-for="item in examList" :key="item.exam.id" :title="'考试期数:' + item.exam.examTime">
      <van-cell title="考生姓名" :value="student.realName" />
      <van-cell title="申领类型" :value="getApplyType(item.exam.applyType)" />
      <van-cell title="单位类型" :value="getWorkType(item.exam.workType)" />
      <van-cell title="资格类型" :value="getQulType(item.exam.qualificationType)" />
      <van-cell title="考试地点" :value="item.exam.address" />
      <van-cell title="考试时间" :value="item.exam.times" />
      <van-cell title="允许手机考试" :value="item.exam.isPhoneExam == 1 ? '是' : '否'" />
      <van-cell title="考试状态" :value="getStatus(item.exam.status)" />
      <!-- <van-cell title="人脸认证" :value="getCompare(item.examStudent.compareFace)" /> -->
      <van-cell title="备注" :value="item.exam.remark" v-if="item.exam.remark != null" />
      <van-cell title="得分" :value="item.examStudent.score"
        v-if="item.examStudent.status == 3 || (item.examStudent.resets > 0)" />
      <van-cell title="补考得分" :value="item.examStudent.reScore"
        v-if="item.examStudent.resets != null && item.examStudent.resets > 0 && item.examStudent.status == 3" />
      <div style="margin: 16px;">
        <!-- <van-button round block type="info" v-if="item.examStudent.compareFace == null" is-link
          :to="'/compareFace?id=' + item.examStudent.id">人脸识别</van-button> -->
        <!-- <van-button round block type="info" v-if="item.examStudent.compareFace == 1 && item.examStudent.status == 0"
          @click="goOnlineExam(item.examStudent.id)">开始考试</van-button>
        <van-button is-link round block type="info" :to="'/examonline?examid=' + item.examStudent.id"
          v-if="item.examStudent.compareFace == 1 && item.examStudent.status == 1">继续考试</van-button> -->
        <van-button round block type="info" v-if="item.examStudent.status == 0"
          @click="goOnlineExam(item.examStudent.id)">开始考试</van-button>
        <van-button is-link round block type="info" :to="'/examonline?examid=' + item.examStudent.id"
          v-if="item.examStudent.status == 1">继续考试</van-button>
      </div>
    </van-cell-group>

  </div>
</template>

<script>
import { getOnlineExam } from '../../api/onlineexam';
import { getDictData } from "../../api/custom";
export default {
  data() {
    return {
      examList: [],
      hasExam: false,
      student: {},
      applyTypeList: [],
      workTypeList: [],
      quaList: [],
    }

  },
  created() {

    //申领资格
    getDictData("sys_apply_type").then(res => {
      this.applyTypeList = res.data.list
    })

    //单位类型
    getDictData("exam_work_type").then(res => {
      this.workTypeList = res.data.list
    })
    //资格类型
    getDictData("sys_qulification_type").then(res => {
      this.quaList = res.data.list
    })
    getOnlineExam().then(res => {
      console.log(res.data)
      if (res.code == 202) {
        this.$dialog.alert({
          message: res.message
        }).then(() => {
          this.$router.push("bindCard")
        })
      } else {
        if (res.success) {
          this.hasExam = true
          this.examList = res.data.list
          this.student = res.data.student
        } else {
          this.$dialog.alert({
            message: res.message
          }).then(() => {
            this.$router.back()
          })
        }
      }


    })
  },
  methods: {
    goOnlineExam(id) {
      localStorage.removeItem(id + "-que")
      localStorage.removeItem(id + "-count")
      localStorage.removeItem(id + "-answerList")
      localStorage.removeItem(id + "-queNow")
      this.$router.push("/examonline?examid=" + id)
    },
    getStatus(val) {
      if (val == 0) {
        return '未开考'
      } else if (val == 1) {
        return '考试中'
      } else if (val == 2) {
        return '考试结束'
      }
    },
    getCompare(val) {
      if (val == 1) {
        return '认证通过'
      } else if (val == 0) {
        return '认证失败'
      } else {
        return '未认证'
      }
    },
    onClickLeft() {
      this.$router.back()
    },

    onClickRight() {
      this.$router.push("/home")
    },
    getQulType(val) {
      let result = ""
      this.quaList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getApplyType(val) {
      let result = ""
      this.applyTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
    getWorkType(val) {
      let result = ""
      this.workTypeList.forEach(item => {
        if (item.dictValue == val) {
          result = item.dictLabel
        }
      })
      return result;

    },
  }

};
</script>

<style lang="less"></style>

